// extracted by mini-css-extract-plugin
module.exports = {"typePositive":"p0YI0KdW","typeNegative":"aYgqHC5V","typeMedian":"nVk5_o4R","dashed":"zoCUhAEh"};